const menu = document.querySelector('body > header .menu-panel')
document.addEventListener('click', (e) => {
  const target = e.target.closest('.open-menu, .close-menu')
  if (!target) return
  menu.classList.toggle('menu-open')
})
